import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import FormModal from '@/components/ui/FormModal';
import RemoveScanForm from '@patientMenu/form/RemoveScanForm.tsx';
import { useDeleteJawsScan } from '@hooks/useJawsScan';
import { usePatientDetailStore } from '@patientMenu/hooks/usePatientDetailStore';

export function RemoveScan() {
  useDocumentTitle("Patients - Remove Scan | name surname");
  const navigate = useNavigate();
  const { patientId, scanId } = useParams<{ patientId: string; scanId: string }>();
  const { selectedScan, setSelectedScan } = usePatientDetailStore();

  const form = useForm();
  const scanMut = useDeleteJawsScan();

  const close = () => {
    navigate(-1);
  };

  const onSubmit = () => {
    scanMut.mutate(
      { scanId: scanId!, patientId: patientId! },
      {
        onSuccess: () => {
          if (selectedScan?.id === scanId) {
            setSelectedScan(null);
          }
          navigate(`/patients/${patientId}`, { replace: true });
        },
        onError: (error) => {
          console.error('Error removing scan:', error); //TODO  Handle error appropriately
        },
      },
    );
  };

  return (
    <FormProvider {...form}>
      <FormModal submitText="Remove" submitButton="destructive" onSubmit={form.handleSubmit(onSubmit)} onClose={close}>
        <RemoveScanForm />
      </FormModal>
    </FormProvider>
  );
}
